export default "__VITE_ASSET__cfb3b0b0__"